// React Dependencies
import React from 'react';

// External Dependencies
import _ from 'lodash';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Container, Modal } from '@material-ui/core';

// Internal Dependecies
import { GiftType } from '../../../../common/constants';
import ApiService from '../../../../services/apiService';
import Colours from '../../../../styles/colours';
import MText from '../../../../components/Common/MText';

const useStyles = makeStyles(() => ({
  paper: {
    position:                    'absolute',
    padding:                     '16px 12px',
    width:                       640,
    backgroundColor:             '#FFF',
    border:                      'none',
    borderRadius:                '8px',
    top:                         `50%`,
    left:                        `50%`,
    transform:                   `translate(-50%, -50%)`,
    '@media (max-width: 720px)': {
      width:  '85%',
      height: '400px',
    },
  },
  voucherList: {
    height:                      '280px',
    border:                      '1px solid #565353',
    overflowY:                   'scroll',
    '@media (max-width: 720px)': {
      height: '120px',
    },
  },
}));

function ClaimModal(props) {
  const classes = useStyles();

  const onShopperGiftClaim = async () => {
    try {
      // TODO: need to show loading indicator
      await ApiService.updateShopperGiftsAsClaimed(props.pageId, props.gift?.id, { shopperGiftIds: props.giftsToClaim.join('|') });

      // TODO: to refresh table on success
      toast.success(`${props.gift?.type === GiftType.Voucher ? 'Voucher(s)' : 'Coupon(s)'} updated as claimed`);
    } catch (err) {
      // TODO: to hide loading indicator
      toast.error(err.message);
    } finally {
      props.onClose();
    }
  };

  return (
    <Modal
      open={props.open}
      onClose={props.onClose}
    >
      <div className={classes.paper}>
        <Container className="py-2 px-3">
          <MText text="Process Claim(s)" variant="h6" />
          <MText
            className="my-2"
            variant="body2"
            text="Indicate the participating outlet(s) has claimed the redeemed voucher(s) or coupon(s) from us"
          />
          <div className="mt-3">
            <MText
              className="mb-1"
              colour={Colours.Gray1}
              text="You have selected the following:"
              variant="body2"
            />
            <div className={`${classes.voucherList} w-100 p-3`}>
              {
              _.map(props.giftsToClaim, (gift) => <MText key={gift} text={gift} bold />)
              }
            </div>
            <MText className="my-2" variant="body2" colour={Colours.Gray1} text={`Total: ${props.giftsToClaim.length}`} />
          </div>
          <div className="d-flex justify-content-end">
            <Button onClick={props.onClose}>Cancel</Button>
            <Button className="ml-3" variant="contained" color="primary" onClick={onShopperGiftClaim}>Submit as Claimed</Button>
          </div>
        </Container>
      </div>
    </Modal>
  );
}

ClaimModal.propTypes = {
  pageId: PropTypes.string.isRequired,
  gift:   PropTypes.shape({
    id:   PropTypes.string,
    type: PropTypes.oneOf([GiftType.Coupon, GiftType.Voucher]),
  }).isRequired,
  open:         PropTypes.bool.isRequired,
  onClose:      PropTypes.func.isRequired,
  giftsToClaim: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ClaimModal;
